import {
  addCopilotTranscriptionUsageMutation,
  copilotQuotaQuery,
  copilotTranscriptionUsageQuery,
} from '@pique/graphql';
import { Store } from '@toeverything/infra';

import type { GraphQLService } from '../services/graphql';

export class UserCopilotQuotaStore extends Store {
  constructor(private readonly graphqlService: GraphQLService) {
    super();
  }

  async fetchUserCopilotQuota(abortSignal?: AbortSignal) {
    const data = await this.graphqlService.gql({
      query: copilotQuotaQuery,
      context: {
        signal: abortSignal,
      },
    });

    if (!data.currentUser) {
      throw new Error('No logged in');
    }

    return data.currentUser.copilot.quota;
  }

  async fetchMonthlyTranscriptionUsage(
    period?: string,
    abortSignal?: AbortSignal
  ) {
    type Resp = {
      currentUser?: {
        copilot: {
          transcriptionUsage: { period: string; usedSeconds: number };
        };
      };
    };

    const data = (await this.graphqlService.gql({
      query: copilotTranscriptionUsageQuery,
      variables: {
        period,
      },
      context: { signal: abortSignal },
    })) as Resp;

    if (!data.currentUser) throw new Error('No logged in');
    return data.currentUser.copilot.transcriptionUsage;
  }

  async reportMonthlyTranscriptionUsage(
    deltaSeconds: number,
    period?: string,
    abortSignal?: AbortSignal
  ) {
    type Resp = {
      addCopilotTranscriptionUsage: { period: string; usedSeconds: number };
    };
    const yyyymm =
      period ?? new Date().toISOString().slice(0, 7).replace('-', '');
    const data = (await this.graphqlService.gql({
      query: addCopilotTranscriptionUsageMutation,
      variables: { deltaSeconds, period: yyyymm },
      context: { signal: abortSignal },
    })) as unknown as Resp;
    return data.addCopilotTranscriptionUsage;
  }
}
